import {attendeeFetchData} from "./index";


const speakersAPI = {
  fetch: (attendeeId,search) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/speakers`, {params: search ? {search} : {}})
}

export default speakersAPI
